export default function formatPrice(price) {
  if (!price || !price.toString) { return ''; }
  let formattedPrice = price.toString().split(".");
  if (formattedPrice.length === 2 && formattedPrice[1] != "0" && formattedPrice[1].length === 1) {
    formattedPrice[1] = formattedPrice[1] + "0"
  }
  return formattedPrice;
}
